import { ITelegramAccountRepository } from '../../ports/ITelegramAccountRepository';

export class DeleteTelegramAccountUseCase {
  constructor(private repo: ITelegramAccountRepository) {}
  async execute(uuid: string): Promise<void> { return this.repo.delete(uuid); }
}
